import * as React from 'react';

import * as styles from './HintQuestionsLayout.css';

interface IHintQuestionsLayoutProps {
  hintQuestions: React.ReactNode;
  banner: React.ReactNode;
}

export const HintQuestionsLayout: React.FC<IHintQuestionsLayoutProps> = ({ hintQuestions, banner }) => {
  return (
    <div className={styles['container']}>
      {banner}
      <div className={styles['hints-container']}>{hintQuestions}</div>
    </div>
  );
};
